/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './integration-endpoint-attribute.reducer';

export const IntegrationEndpointAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const integrationEndpointAttributeEntity = useAppSelector(state => state.integrationEndpointAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="integrationEndpointAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.detail.title">IntegrationEndpointAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.name}</dd>
          <dt>
            <span id="defaultValue">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.defaultValue">Default Value</Translate>
            </span>
            <UncontrolledTooltip target="defaultValue">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.defaultValue" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.defaultValue}</dd>
          <dt>
            <span id="example">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.example">Example</Translate>
            </span>
            <UncontrolledTooltip target="example">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.example" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.example}</dd>
          <dt>
            <span id="mandatory">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.mandatory">Mandatory</Translate>
            </span>
            <UncontrolledTooltip target="mandatory">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.mandatory" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.mandatory ? 'true' : 'false'}</dd>
          <dt>
            <span id="userSpecific">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.userSpecific">User Specific</Translate>
            </span>
            <UncontrolledTooltip target="userSpecific">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.userSpecific" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.userSpecific ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationEndpointAttributeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.coFormat">Co Format</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.coFormat ? integrationEndpointAttributeEntity.coFormat.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.ciFormat">Ci Format</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.ciFormat ? integrationEndpointAttributeEntity.ciFormat.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.attributeType">Attribute Type</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.attributeType ? integrationEndpointAttributeEntity.attributeType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.valueType">Value Type</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.valueType ? integrationEndpointAttributeEntity.valueType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.valueRange">Value Range</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.valueRange ? integrationEndpointAttributeEntity.valueRange.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.endpoint">Endpoint</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.endpoint ? integrationEndpointAttributeEntity.endpoint.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.parent">Parent</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.parent ? integrationEndpointAttributeEntity.parent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.tenantAttribute">Tenant Attribute</Translate>
          </dt>
          <dd>{integrationEndpointAttributeEntity.tenantAttribute ? integrationEndpointAttributeEntity.tenantAttribute.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/integration-endpoint-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/integration-endpoint-attribute/${integrationEndpointAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntegrationEndpointAttributeDetail;
